import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";

const AddToCartButton = ({ isProcessing, isLoading, handleAddToCart }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={isProcessing}
        onClick={handleAddToCart}>
        {isLoading ? (
          <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
        ) : (
          "Add to Cart"
        )}
      </Button>
    </Box>
  );
};

export default AddToCartButton;
